import { FormSection, FormSectionHelpText, Indent } from '@ui-components/neo.tax';
import React from 'react';

import { FormItemFactory } from './FormItemFactory';
import { FormType } from './forms.enums';
import { FormItemFactoryContainer } from './forms.styled';
import { Form } from './forms.types';

export const FormSectionRecursive = ({ form }: { form: Form }): React.ReactElement => {
  if (form.formType === FormType.FORM_TITLE) {
    return <FormSection title={form.title} subtitle={form.subtitle} />;
  }

  return (
    <FormSection title={form.title} subtitle={form.subtitle}>
      <FormItemFactoryContainer>
        <FormItemFactory form={form} />
        {form.helpText && <FormSectionHelpText>{form.helpText}</FormSectionHelpText>}
      </FormItemFactoryContainer>
      {form.subForms && form.subForms.length > 0 && (
        <Indent border>
          {form.subForms.map((subForm) => (
            <FormSectionRecursive key={subForm.key} form={subForm} />
          ))}
        </Indent>
      )}
    </FormSection>
  );
};
